import IndexPageComponent from "../page-components/index";
import {GetServerSideProps} from "next";
import React from "react";
import MobileIndex from "../page-components/mobile";

// 用于检查User-Agent字符串是否符合移动设备特征的简易函数
const isMobile = (userAgent: string): boolean => {
  return /iPhone|iPad|iPod|Android/i.test(userAgent);
}

const IndexPage = () => {
  const [isMobileDevice, setIsMobileDevice] = React.useState(false);
  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const userAgent = window.navigator.userAgent;
      setIsMobileDevice(isMobile(userAgent));
      window.addEventListener('resize', () => {
        window.location.reload()
      })
    }
  }, [])
  if (!isMobileDevice) {
    return <IndexPageComponent />
  } else {
    return <MobileIndex />
  }

}

export default IndexPage
